import { z } from 'zod';
import { WindowCurrentUserSchema } from 'types/users';
export var InitialDataSchema = z.object({
    current_user: WindowCurrentUserSchema
});
